import PropTypes from 'prop-types';
import React, { useState } from "react";

import { connect } from "react-redux";

import { Link } from "react-router-dom";

// Redux Store
import { showRightSidebarAction, toggleLeftmenu } from "../../store/actions";
// reactstrap
// Import menuDropdown
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import logoLight from "../../assets/images/ci-light.png";
import logo from "../../assets/images/ci_logo.png";
//i18n
import { withTranslation } from "react-i18next";
import OurProducts from 'components/CommonForBoth/TopbarDropdown/ourProducts';

const Header = props => {
  const [isSearch, setSearch] = useState(false);

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex align-items-center">
            <button
              type="button"
              className="btn btn-sm px-3 font-size-16 d-lg-none header-item"
              data-toggle="collapse"
              onClick={() => {
                props.toggleLeftmenu(!props.leftMenu);
              }}
              data-target="#topnav-menu-content"
            >
              <i className="fa fa-fw fa-bars" />
            </button>
            <div className="navbar-brand-box" style={{marginLeft:'-15px'}}>
              <Link to="/customer/dashboard" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logoLight} alt="" height="28" />
                </span>
                <span className="logo-lg">
                  <img src={logo} alt="" height="28" />
                </span>
              </Link>
              <Link to="/customer/dashboard" className="logo logo-light">
                <span className="logo-sm">
                  <img src="https://payearly.cashinvoice.in/assets/images/CashInvoiceLogo.png" alt="" height="28" />
                </span>
                <span className="logo-lg">
                  <img src={logo} alt="" height="28" />
                </span>
              </Link>
            </div>
          </div>

          <div className="d-flex">
            <OurProducts />
            <NotificationDropdown />
            <ProfileMenu />
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

Header.propTypes = {
  leftMenu: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func
};

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar, leftMenu } = state.Layout;
  return { layoutType, showRightSidebar, leftMenu };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
})(withTranslation()(Header));
